import { useDispatch } from "react-redux";
import { reset } from "features/auth/authSlice";
import { persistor } from "store";

const SIGNOUT_URL = process.env.REACT_APP_SIGNOUT_URL!;

const isLocalEnv =
  process.env.REACT_APP_ENV === "local" ||
  (typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1"));

const useSignOut = () => {
  const dispatch = useDispatch();

  return () => {
    dispatch(reset());
    persistor.purge().then(() => {
      if (isLocalEnv) {
        window.location.replace(window.location.origin);
      } else {
        window.location.replace(SIGNOUT_URL);
      }
    });
  };
};

export { useSignOut };
